import React, { createContext } from "react";

export const NotificationContext = createContext();
